import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SearchOverlay from './SearchOverlay';
import { useCart } from '../../context/CartContext';
import { getCategories } from '../../api/apiServices';
import logo from '../../asset/SISILOGO.png';
import { slugify } from '../../utils/slugify';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { cartCount, setIsCartOpen } = useCart();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
    /* ---------------- LOAD DATA ---------------- */
  
    useEffect(() => {
      const loadData = async () => {
        try {
          setLoading(true);
  
          const [categoriesRes] = await Promise.all([
            getCategories(),
          ]);
  
          setCategories(categoriesRes.data || []);
        } catch (err) {
          console.error("Failed to load shop data:", err);
        } finally {
          setLoading(false);
        }
      };
  
      loadData();
    }, []);
  

  const shouldShowWhiteBg = isScrolled || !isHomePage;

  return (
    <>
    <nav className={`fixed top-0 w-full z-40 transition-all duration-300 ${shouldShowWhiteBg ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="w-full max-w-[1200px] mx-auto px-4 flex items-center justify-between py-4">
        <Link to="/" className="flex items-center">
          <img
          src={logo}
          alt="SISI"
          className="h-9 md:h-10 transition-all duration-300"
          />
        </Link>

        <div className="hidden md:flex gap-6 lg:gap-8 font-medium items-center">
          {categories.slice(0, 6).map((category) => (
            <Link
              key={category._id}
              to={`/products/${slugify(category.name)}`}
              className={`transition-all duration-200 hover:text-[#EF579A] whitespace-nowrap text-sm font-['Poppins'] cursor-pointer ${shouldShowWhiteBg ? 'text-gray-700' : 'text-white'}`}
            >
              {category.name}
            </Link>
          ))}
          <Link
            to="/products/all"
            className="text-[#EF579A] font-semibold text-sm font-['Poppins'] hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer"
          >
            All categories
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setIsSearchOpen(true)}
            className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${shouldShowWhiteBg ? 'text-gray-700 hover:text-[#EF579A]' : 'text-white hover:text-[#EF579A]'}`}
          >
            <i className="ri-search-line text-xl"></i>
          </button>
          {/* <button className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${shouldShowWhiteBg ? 'text-gray-700 hover:text-[#EF579A]' : 'text-white hover:text-[#EF579A]'}`}>
            <i className="ri-heart-line text-xl"></i>
          </button> */}
          <button 
            onClick={() => setIsCartOpen(true)}
            className="bg-[#EF579A] flex justify-center items-center w-10 h-10 rounded-full relative cursor-pointer hover:bg-[#d94a87] transition-colors"
          >
            <i className="ri-shopping-bag-line text-white text-lg"></i>
            <div className="w-5 h-5 bg-white absolute flex justify-center items-center text-[#EF579A] -right-1 -top-1 rounded-full shadow-sm">
              <p className="text-[10px] font-bold">{cartCount}</p>
            </div>
          </button>
          
          <div className="md:hidden relative">
            <button
              onClick={() => setShowCategories(!showCategories)}
              className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${shouldShowWhiteBg ? 'text-gray-700' : 'text-white'}`}
            >
              <i className={`${showCategories ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
            {showCategories && (
              <div className="absolute top-full mt-2 right-0 bg-white rounded-xl shadow-lg py-3 min-w-[180px]">
                {categories.map((category) => (
                  <Link
                    key={category.slug}
                    to={`/products/${slugify(category.name)}`}
                    onClick={() => setShowCategories(false)}
                    className="block w-full text-left px-5 py-2.5 text-gray-700 hover:text-[#EF579A] hover:bg-pink-50 text-sm font-['Poppins'] cursor-pointer"
                  >
                    {category.name}
                  </Link>
                ))}
                {/* <Link
                  to="/products/all"
                  onClick={() => setShowCategories(false)}
                  className="block w-full text-left px-5 py-2.5 text-[#EF579A] font-semibold hover:bg-pink-50 text-sm font-['Poppins'] cursor-pointer"
                >
                  All Categories
                </Link> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
    <SearchOverlay isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
}
